import { IFormattedTime } from 'models/common.model'

import { SECONDS_IN_MINUTE, TIMER_DIGIT_LENGTH } from 'root-constants'

export const getDecoratedObjectTimerValue = (
  valueInSeconds: number,
): IFormattedTime => {
  const minutes = Math.trunc(valueInSeconds / SECONDS_IN_MINUTE)
  const seconds = valueInSeconds - minutes * SECONDS_IN_MINUTE
  const get2DigitValue = (value: number): string =>
    value.toString().padStart(TIMER_DIGIT_LENGTH, '0')

  return {
    minutes: get2DigitValue(minutes),
    seconds: get2DigitValue(seconds),
  }
}

export const getDecoratedStringTimerValue = (
  valueInSeconds: number,
): string => {
  const minutes = Math.trunc(valueInSeconds / 60)
  const seconds = valueInSeconds - minutes * 60
  const get2DigitValue = (value: number): string =>
    value.toString().padStart(2, '0')

  return `${get2DigitValue(minutes)}:${get2DigitValue(seconds)}`
}
